import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-icon-modal-content',
  templateUrl: './icon-modal-content.component.html',
  styleUrl: './icon-modal-content.component.scss',
  standalone: false
})
export class IconModalContentComponent {
  icons: string[] = [
    '../../../../assets/icons/v3-bps/asset-icons/TS.svg',
    '../../../../assets/icons/v3-bps/asset-icons/LV.svg',
    '../../../../assets/icons/v3-bps/asset-icons/MV-11.svg',
    '../../../../assets/icons/v3-bps/asset-icons/MV-33.svg',
    '../../../../assets/icons/v3-bps/asset-icons/HV-more.svg',
    '../../../../assets/icons/v3-bps/asset-icons/HV-33.svg',
    '../../../../assets/icons/v3-bps/asset-icons/DT.svg',
    '../../../../assets/icons/v3-bps/asset-icons/INJ-SS.svg',
    '../../../../assets/icons/v3-bps/asset-icons/SS.svg',
    '../../../../assets/icons/v3-bps/asset-icons/building-customers.svg',
    '../../../../assets/icons/v3-bps/asset-icons/non-compliant.svg',
    '../../../../assets/icons/v3-bps/asset-icons/compliant.svg',
    '../../../../assets/icons/v3-bps/asset-icons/CBO.svg',
    '../../../../assets/icons/v3-bps/asset-icons/area.svg',
    '../../../../assets/icons/v3-bps/asset-icons/meter.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Users.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Readings.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Customers-2.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Customer-nopower.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Roles&Permissions.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Customers-1.svg',
    '../../../../assets/icons/v3-bps/asset-icons/OutageOptions-2.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Customer-power.svg',
    '../../../../assets/icons/v3-bps/asset-icons/History.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Hierarchy.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Customer-noDT.svg',
    '../../../../assets/icons/v3-bps/asset-icons/CustomerAccount.svg',
    '../../../../assets/icons/v3-bps/asset-icons/OutageOptions-1.svg',
    '../../../../assets/icons/v3-bps/asset-icons/CRUD.svg',
    '../../../../assets/icons/v3-bps/asset-icons/Tariffs.svg',
    '../../../../assets/icons/v3-bps/asset-icons/EnergyFlow.svg',
    '../../../../assets/icons/v3-bps/asset-icons/NodeEnergy-1.svg',
    '../../../../assets/icons/v3-bps/asset-icons/NodeEnergy-2.svg',
    '../../../../assets/icons/v3-bps/asset-icons/HistoricalTrend.svg',
    '../../../../assets/icons/v3-bps/asset-icons/AssetComparison.svg',
    '../../../../assets/icons/v3-bps/asset-icons/EnergyDistribution-2.svg',
    '../../../../assets/icons/v3-bps/asset-icons/EnergyDistribution-1.svg',
    '../../../../assets/icons/v3-bps/asset-icons/WatchList.svg',
    '../../../../assets/icons/v3-bps/asset-icons/CRUD-2.svg',
  ];

  constructor(private cdr: ChangeDetectorRef, private toastr: ToastrService) {}

  @Output() svgFile = new EventEmitter<File>();
  @Output() svgFilePath = new EventEmitter<string>();

  selectedIcon: string | null = this.icons[0];
  importedIcon: string | null = null;
  fileName: string;

  selectIcon(icon: string) {
    this.importedIcon = null; 
    this.selectedIcon = icon;
    this.svgFilePath.emit(this.selectedIcon);
  }

  onFileSelected(event: Event) {
    this.selectedIcon = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

    if (!file.name.endsWith('.svg')) {
      this.toastr.error('SVG format required.');
      input.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.importedIcon = reader.result as string; 
    };
    reader.readAsDataURL(file);

    this.fileName = file.name;
    this.svgFile.emit(file);
  }
}

}
